import { IconGrid } from "../icons/Icons";

export default function HomeView() {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24 }}>
      <div style={{ width: 64, height: 64, background: "#1e6b6b", borderRadius: 16, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 18px rgba(30,107,107,0.25)" }}>
        <IconGrid />
      </div>
      <div style={{ textAlign: "center" }}>        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: "#1e6b6b", letterSpacing: 0.5 }}>Vehicle Planning</h1>
        <p style={{ margin: "8px 0 0", fontSize: 13, color: "#888" }}>Vehicle Planning Overview</p>
      </div>
      <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
        {["Year View", "Month View"].map(label => (
          <div key={label} style={{ padding: "8px 18px", background: "#eaf0ef", borderRadius: 20, fontSize: 12, color: "#1e6b6b", fontWeight: 600, cursor: "default" }}>
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
